import { render, staticRenderFns } from "./AdminHelp.vue?vue&type=template&id=2fc901b7&"
import script from "./AdminHelp.vue?vue&type=script&lang=js&"
export * from "./AdminHelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports